import React, { memo, forwardRef } from 'react';
import { TextInput } from 'react-native';
import { Text, Box, Input } from '@bonanza-social/moonlight';
import { InputSelectProps } from './InputSelect.types';
import Select from '../Select/Select';
import { useInputSelect } from './hooks/useInputSelect';

const InputSelect = forwardRef<TextInput, InputSelectProps>(
  (
    {
      selectableOptions = [],
      centerContent = false,
      useDynamicSelectableOptions = false,
      autoFocus = true,
      allowEmptyField = true,
      dynamicSelectableOptionsCallback,
      maxHeight = 300,
      headerKey,
      headerNS,
      buttonKey,
      buttonNS,
      onSelect,
      defaultValue,
      close,
    },
    ref,
  ) => {
    const {
      inputValue,
      filteredSuggestions,
      handleInputChange,
      handleOnFocus,
      handleOnBlur,
      handleOnPress,
    } = useInputSelect(
      selectableOptions,
      dynamicSelectableOptionsCallback,
      useDynamicSelectableOptions,
      defaultValue,
    );

    return (
      <Box marginTop="space-300">
        {headerNS && headerKey && (
          <Text
            color="darkSurfacePrimary"
            variant="h5"
            locNS={headerNS}
            locKey={headerKey}
          />
        )}
        <Input
          ref={ref}
          icon="search"
          autoFocus={autoFocus}
          onChangeText={handleInputChange}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          value={inputValue}
          borderRadius="radius-full"
          marginTop="space-300"
          testID='bottom-sheet-search-text-input'
        />
        <Select
          selectableOptions={filteredSuggestions}
          centerContent={centerContent}
          allowEmptyField={allowEmptyField}
          maxHeight={maxHeight}
          buttonKey={buttonKey}
          buttonNS={buttonNS}
          onSelect={onSelect}
          onPress={handleOnPress}
          clearSelectedValue={!inputValue?.trim()}
          close={close}
          testID='bottom-sheet-select-input'
        />
      </Box>
    );
  },
);

InputSelect.displayName = 'InputSelect';

export default memo(InputSelect);
